import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { Navigation } from 'src/modules/navigation';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { Footer } from 'src/modules/footer';
import { FooterFormContext } from 'utils/footer-context/index';
import layout from 'constants/styles/layout';
import { GlobalStyle } from 'src/styles/globalStyle';

const SAppWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
`;

const SAppWidthLimit = styled.div`
    width: 100%;
    max-width: ${layout.contentMaxWidth};
    padding: ${layout.contentSpacing};
    position: relative;
`;

type Props = {
    children: ReactNode;
};

export const Layout = ({ children }: Props) => {
    const data = useStaticQuery(graphql`
        query SiteTitleQuery {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `);

    return (
        <SAppWrapper>
            <GlobalStyle />
            <FooterFormContext>
                <SAppWidthLimit>
                    <Navigation siteTitle={data.site.siteMetadata?.title || `Title`} />
                    <main>{children}</main>
                </SAppWidthLimit>
                <Footer />
            </FooterFormContext>
        </SAppWrapper>
    );
};
